import { ComponentStyleConfig } from "@chakra-ui/react";

const constructCheckboxStyle = (color: string) => ({
  borderRadius: 2,
  borderColor: "gray.700",
  _checked: {
    bg: color,
    borderColor: color,
  },
});

const Checkbox: ComponentStyleConfig = {
  baseStyle: ({ colorScheme }) => ({
    control: constructCheckboxStyle(`${colorScheme}.600`),
  }),
};

export default Checkbox;
